export default __webpack_public_path__ + "static/favicon-974bd3004d4ed55747cedf0a64162eba.png";